import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';

// Blog is public content — no auth needed.
const publicApi = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api/v1',
});

export const getBlogPosts = (params) =>
  publicApi.get(ENDPOINTS.blog.list, { params }).then((r) => r.data.data);

export const getBlogPostBySlug = (slug) =>
  publicApi.get(ENDPOINTS.blog.bySlug(slug)).then((r) => r.data.data.post);
